// extracted by mini-css-extract-plugin
export default {"wrapper":"Message_wrapper__AESg9","blockMsg":"Message_blockMsg__8lxbr","avatar":"Message_avatar__D2X7h","avatarBg":"Message_avatarBg__pp-rk","nameAuthor":"Message_nameAuthor__F9zKN"};